import { render, staticRenderFns } from "./ConfigurationMenu.vue?vue&type=template&id=063850eb"
import script from "./ConfigurationMenu.vue?vue&type=script&lang=js"
export * from "./ConfigurationMenu.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationMenu.vue?vue&type=style&index=0&id=063850eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports